<template>
  <div id="game" class="pos-abs pos-center-hor pos-center-ver">
    <iframe :src="gameUrl" 
      allowtransparency="true" frameborder="0" scrolling="no"
      class="wistia_embed" v-bind:class="is_landscape?'landscape':'portrait'" name="wistia_embed" allowfullscreen
      mozallowfullscreen webkitallowfullscreen oallowfullscreen
      msallowfullscreen width="100%" height="100%" @load="load">
    </iframe>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/navigator.sendbeacon"></script>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  let contact_number = "", partner_id = "", tr_id = 0, seconds = 0;
  export default {
    mixins: [globals],
    props: {
      model: String
    },
    data() {
      return {
        gameUrl: "",
        is_landscape: false,
        // partner_id: "",
        // contact_number: "",
        // tr_id: 0,
        startTime: Date.now(),
        currentTime: Date.now(),
        interval: null
        // seconds: null
      }
    },
    methods: {
      load(){
        // console.log("~~~~~~~~~~~~loaded");
        this.startStopwatch();
      },
      startStopwatch(){
        this.interval = setInterval(this.updateCurrentTime, 1000);
      },
      stopStopwatch(){
        this.sendTimeSpentToServer();
        clearInterval(this.interval);
      },
      updateCurrentTime() {
        this.currentTime = Date.now();

        var mili = this.currentTime - this.startTime;
        seconds = Math.ceil((mili / 1000) % 60);

        // console.log("~~~~~~~~~~~~"+seconds);
      }
    },
    created() {
      var self = this;
      self.$store.state.showHeader = false;
      const urlParams = new URLSearchParams(window.location.search);
      if(urlParams.has('url') && urlParams.get('url').length > 0) {
        self.gameUrl = decodeURIComponent(urlParams.get('url'));
        self.is_landscape = urlParams.get('is_landscape') == 'true';
        partner_id = urlParams.get('partner_id');
        contact_number = urlParams.get('contact_number');
        tr_id = urlParams.get('tr_id');
      } else {
        self.back();
      }
    },
    mounted(){
      window.addEventListener('visibilitychange', function (e) {
          // e.preventDefault();
          // e.returnValue = '';
        var url = 'https://www.appbrowzer.com/web_game_sessions?partner='+partner_id;

        var body = {
          tournament_id: tr_id,
          contact_number: contact_number,
          duration: seconds
        }
        var fd = new FormData();
        fd.append('tournament_id', tr_id);
        fd.append('contact_number', contact_number);
        fd.append('duration', seconds);

        if ('sendBeacon' in navigator) {
        navigator.sendBeacon(url, fd);
        }else{
          console.log("no beacon")
        }

        // axios.post(url, body, {
        //   headers: {'X-Key': this.partner_id}
        // }).then((resp) => {
        //   console.log(resp);
        //   if(resp.status == 200 && resp.data.success) {

        //   }
        // }).catch((err) => {})

        this.startTime = Date.now();
        this.currentTime = Date.now();
        clearInterval(this.interval);
      });
      // window.addEventListener('beforeunload', function (e) {
      //     // e.preventDefault();
      //     // e.returnValue = '';
      //   console.log("~~~~~~~~~~destroyed")
      //   this.stopStopwatch();
      // });
    },
    destroyed() {
      this.stopStopwatch();
    }
  }
</script>
<style>
  #game {
    z-index: 3;
  }
  #game iframe.landscape {
    width: 100vh;
    height: 100vw;
    transform: translateX(100vw) rotate(90deg);
    transform-origin: top left;
  }
</style>


// WEBPACK FOOTER //
// src/screens/game.vue